class SkillCard
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'skill-card--bound'
            @.hasBack = @.$el.classList.contains 'skill-card--back'

            @.$el.classList.add 'skill-card--bound'
            if @.hasBack
                @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            self.$el.classList.toggle 'skill-card--active'
            return
        return

BindSkillCards = ->
    document.querySelectorAll '.skill-card:not(.skill-card--bound)'
        .forEach (el) ->
            new SkillCard el
            return
    return

window.addEventListener 'bind-components', BindSkillCards